export default {
  /* turn into class */

  tempCanvas: null,
  blurryTileCanvas: null,

  init() {
    this.tempCanvas = document.createElement('canvas');
    this.blurryTileCanvas = document.createElement('canvas');
  },

  /* get average color */
  _getAverageColor(data) {
    let rgb = { r:0, g:0, b:0 };
    let length = data.data.length;
    let j = -4;
    let count = 0;
    while ( (j += 4) < length ) {
      ++count;
      rgb.r += data.data[j + 0];
      rgb.g += data.data[j + 1];
      rgb.b += data.data[j + 2];
    }
    // ~~ used to floor values
    rgb.r = ~~(rgb.r / count);
    rgb.g = ~~(rgb.g / count);
    rgb.b = ~~(rgb.b / count);

    let color_str = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
    // console.log(color_str);
    return color_str;
  },

  _blurTile(ctx, x, y, boxSize) {

    let ctxTile = this.blurryTileCanvas.getContext('2d');
    this.blurryTileCanvas.width = boxSize;
    this.blurryTileCanvas.height = boxSize;

    let oneTile = ctx.getImageData(x, y, boxSize, boxSize)
    // ctxTile.filter = 'grayscale(80%) blur(10px)';
    // ctxTile.putImageData(oneTile, 0, 0)
    // ctxTile.fillStyle = "blue";

    ctxTile.fillStyle = this._getAverageColor(oneTile);
    ctxTile.fillRect(0, 0, boxSize, boxSize)

    ctx.putImageData(ctxTile.getImageData(0, 0, boxSize, boxSize), x, y)
    // ctx.drawImage(this.blurryTileCanvas, x, y)
  },

  filter(imageData, isSelected) {
    // console.log("MyFilter", imageData, isSelected);

    let W = imageData.width;
    let H = imageData.height;
    let nPixels = imageData.data.length;
    let boxSize = 100;

    this.tempCanvas.width = imageData.width;
    this.tempCanvas.height = imageData.height;

    let ctx = this.tempCanvas.getContext('2d');
    ctx.putImageData(imageData, 0, 0);

    /* dra random boxes for now */
    for ( var z = 0; z < 10; z++ ) {
      let nx = ~~(Math.random() * ((W - boxSize) / boxSize));
      let ny = ~~(Math.random() * ((H - boxSize) / boxSize));
      // console.log("box at", nx, "|", ny);
      this._blurTile(ctx, nx * boxSize, ny * boxSize, boxSize)
    }

    ctx.save();
    ctx.lineWidth = 2;
    if ( isSelected ) {
      /* testing */
      ctx.strokeStyle = 'red';
    } else {
      ctx.strokeStyle = 'blue';
    }
    for ( var x = 0; x < W; x += boxSize ) {
      ctx.beginPath();
      ctx.moveTo( x, 0 );
      ctx.lineTo( x, parseInt(H / boxSize) * boxSize );
      ctx.stroke();
    }
    for ( var y = 0; y < H; y += boxSize ) {
      ctx.beginPath();
      ctx.moveTo( 0, y );
      ctx.lineTo( parseInt(W / boxSize) * boxSize, y );
      ctx.stroke();
    }
    ctx.restore();

    var tempImageData = ctx.getImageData(0, 0, this.tempCanvas.width, this.tempCanvas.height);
    for (var i = 3; i < nPixels; i += 4) {
      imageData.data[i - 0] = tempImageData.data[i - 0];
      imageData.data[i - 1] = tempImageData.data[i - 1];
      imageData.data[i - 2] = tempImageData.data[i - 2];
      imageData.data[i - 3] = tempImageData.data[i - 3];
    }
  }
};
